import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { EmailCampaign, EmailSender, NewEmailCampaign } from '@models/email/email-campaign';
import { compare } from 'fast-json-patch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmailCampaignListService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getListCampaignEmail(status?: string): Observable<EmailCampaign[]> {
    let params = new HttpParams();
    params = status ? params.append('status', status) : null;
    const suffixUrl = 'email/list';
    const url = this.baseUrl + suffixUrl;
    return this.http
      .get<Response[]>(url, { params })
      .pipe(
        map(data => {
          return data.map(d => EmailCampaign.deserialize(d));
        })
      );
  }

  sigleListCampaignEmail(idCampaign: number): Observable<EmailCampaign> {
    const suffixUrl = 'email/list/' + idCampaign;
    const url = this.baseUrl + suffixUrl;
    return this.http.get<Response>(url).pipe(map(data => EmailCampaign.deserialize(data)));
  }

  archavieEmailCampaign(idCampaign: number) {
    const suffixUrl = 'email/list/' + idCampaign;
    const url = this.baseUrl + suffixUrl;
    return this.http.delete(url);
  }

  listEmailSender(): Observable<EmailSender[]> {
    const suffixUrl = 'email/sender';
    const url = this.baseUrl + suffixUrl;
    return this.http.get<Response[]>(url).pipe(
      map(data => {
        return data.map(d => EmailSender.deserialize(d));
      })
    );
  }

  addNewEmailSender(emailSender: string): Observable<EmailSender> {
    const requestBody = { emailSender };
    const suffixUrl = 'email/sender';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, requestBody).pipe(map(data => EmailSender.deserialize(data)));
  }

  deleteEmailSender(idEmailAddress) {
    const suffixUrl = 'email/sender/' + idEmailAddress;
    const url = this.baseUrl + suffixUrl;
    return this.http.delete(url);
  }

  resendValidatorSenderEmail(idEmailAddress) {
    const suffixUrl = 'email/sender/' + idEmailAddress + '/resend-validator';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, null);
  }

  updateListEmailCampaign(idCampaign, currentList, formData) {
    const patch = compare(currentList, formData);
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    const suffixUrl = 'email/list/' + idCampaign;
    const url = this.baseUrl + suffixUrl;
    return this.http.patch<Response>(url, patch, { headers: patchHeaders });
  }

  createListEmailCampaign(formData) {
    const requestBody = NewEmailCampaign.deserialize(formData);
    const suffixUrl = 'email/list';
    const url = this.baseUrl + suffixUrl;
    return this.http.post<Response>(url, requestBody);
  }
}
